import Vue from 'vue';
import Vuex from 'vuex';

import config from './modules/config';
import member from './modules/member';
import course from './modules/course';
import externalCourseModule from './modules/externalCourse';
import externalAssignmentModule from './modules/externalAssignment';
import assignment from './modules/assignment';
import metadata from './modules/metadata';
import abuse from './modules/abuse';
import favorite from './modules/favorite';
import getters from './getters';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    config,
    member,
    course,
    assignment,
    metadata,
    abuse,
    favorite,
    externalCourseModule,
    externalAssignmentModule,
  },
  getters,
});
